/** Legacy redirect (spec-56): old `/postinvest/wasstraat/:itemId` → `/postinvest/startup/:itemId?tab=wasstraat`. */

import { Navigate, useParams } from 'react-router'

export function WasstraatLegacyRedirect() {
  const { itemId } = useParams<{ itemId: string }>()
  return <Navigate to={itemId ? `/postinvest/startup/${itemId}?tab=wasstraat` : '/postinvest'} replace />
}
